import { NumberInput, Group } from '@mantine/core';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';

const FormPriceRangeInput = () => {
  const form = useFilterFormContext();

  return (
    <Group grow>
      <NumberInput
        label="Cena od"
        {...form.getInputProps('priceAmountFrom')}
        min={0}
      />
      <NumberInput
        label="Cena do"
        {...form.getInputProps('priceAmountTo')}
        min={form.values.priceAmountFrom ?? 0}
      />
    </Group>
  );
};

export default FormPriceRangeInput;
